module.exports = __webpack_public_path__ + "img/u384.cc741b07.png";